import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicPartnersVoucherSupplier({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 80 80"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 12C8.477 12 4 16.477 4 22v14h7a4 4 0 010 8H4v14c0 5.523 4.477 10 10 10h52c5.523 0 10-4.477 10-10V44h-7a4 4 0 010-8h7V22c0-5.523-4.477-10-10-10H14zm-2 10a2 2 0 012-2h52a2 2 0 012 2v6.041C61.84 28.55 57 33.71 57 40c0 6.29 4.84 11.45 11 11.959V58a2 2 0 01-2 2H14a2 2 0 01-2-2v-6.041C18.16 51.45 23 46.29 23 40c0-6.29-4.84-11.45-11-11.959V22zm27 9a4 4 0 00-8 0v18a4 4 0 008 0V31z"
        fill="#F4F5FB"
      />
    </svg>
  );
}

SvgPicPartnersVoucherSupplier.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicPartnersVoucherSupplier.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicPartnersVoucherSupplier svgRef={ref} {...props} />
));
export default ForwardRef;
